import Vue from "vue";

import Footer from "./Footer.vue";

export function load(payload) {
    const selector = "site-footer";
    const store = payload;
    // Is the custom Vue root element in the DOM?
    if (!document.querySelector(selector)) {
        return;
    }

    // Create a new Vue app with the imported Home component
    new Vue({
        store,
        render: createElement =>
            createElement(Footer, {
                props: {
                    ...window[selector],
                },
            }),
    }).$mount(selector);
}